import { render } from "./PaymentReceiptComponent.vue?vue&type=template&id=6eee8126"
import script from "./PaymentReceiptComponent.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptComponent.vue?vue&type=script&lang=js"

import "./PaymentReceiptComponent.vue?vue&type=style&index=0&id=6eee8126&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__